<template>
  <th :class="thClass" scope="col">
    <v-text-field
      hide-details
      dense
      clearable
      type="date"
      :label="labelValue"
      v-bind="$attrs"
      v-on="$listeners"
      solo
    />
  </th>
</template>

<script>
import MobileHelper from "@/mixins/MobileHelper";
export default {
  props: {
    label: {
      type: String,
      required: false,
    },
  },
  mixins: [MobileHelper],
  computed: {
    labelValue() {
      if (this.mobile) {
        return this.label;
      }
      return null;
    },
    thClass() {
      if (this.mobile) {
        return "v-data-table__mobile-row";
      }
      return null;
    },
  },
};
</script>

<style scoped>
th {
  background: rgba(0, 0, 0, 0.06);
}
</style>
